module.exports = __webpack_public_path__ + "img/icon-logo.8513a22a.svg";